import styled from "styled-components";

export const CustomMessage = styled.span`
  color: ${({ theme }) => theme.message.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  width: 500px;
  display: block;

  @media (max-width: 767px) {
    width: auto;
  }
`;
